import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import PropTypes from 'prop-types';
import AlertDownload from '../../container/AlertDownload';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'approve.page.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Approval'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class ApproveMsg extends Component {
  //const { intl } = props;
  static propTypes = {
    approve: PropTypes.func.isRequired
  };
  //const fileList = project.files;
  constructor(props) {
    super(props);
    const { intl } = this.props;
  }
  componentDidMount() {
    if (this.props.nextaction == 'approve') {
      this.props.approve(
        this.props.memberusername,
        this.props.memberemail,
        this.props.membername,
        this.props.memberrole
      );
    }

    if (this.props.nextaction == 'sendfinalapprove') {
      this.props.sendfinalapprove(
        this.props.memberusername,
        this.props.memberemail,
        this.props.membername,
        this.props.memberrole
      );
    }

    if (this.props.nextaction == 'reject') {
      this.props.reject(this.props.memberusername);
    }
  }

  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - Shift
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />
        <AlertDownload
          title={this.props.intl.formatMessage(messages.headerTitle)}
          message={print(this.props.status)}
        />
        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm>
              <div className="form">
             
{this.props.nextaction != 'sendfinalapprove' ? (      <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%',
                    color: '#A9A9A9'
                  }}
                >
                  The user's account has been{' '}
                  {this.props.nextaction == 'approve' ? 'approved' : 'rejected'}
                  . A notification email has been sent to the user.
                </label>
): ( <label
style={{
  width: '90%',
  fontSize: '16px',
  textTransform: 'none',
  lineHeight: '150%',
  color: '#A9A9A9'
}}
>
 A notification email has been sent to the final account approver.
</label>)

}
                <br />
                <br />
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={() => this.props.clickOKHandler()}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(ApproveMsg);



// WEBPACK FOOTER //
// ./src/components/views/ApproveMsg/index.js